// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const tn: CountryValidator<"EG"> = createValidator(
  "eg.tn",
  64,
);

export default tn;
export const compact = tn.compact;
export const format = tn.format;
export const validate = tn.validate;
export const generate = (): string =>
  tn.generate?.() ??
  (() => {
    throw new Error(
      "Validator eg.tn cannot generate values",
    );
  })();
